module.exports = __webpack_public_path__ + "img/16.3e6281b1.png";